import React from 'react';
import { string, object } from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import LinkButton from '../common/LinkButton';
import ExportStudentProfile from './ExportStudentProfile';
import { studentPermission } from '../../utils/helpers';

const StudentProfileMenu = ({ student, view, user }) => (
  <div id="student-profile-menu">
    <Link
      className={view === 'basica' || !view ? 'item-active' : 'item'}
      to={`/alumnos/${student.id}/basica`}
    >
      Básica
    </Link>
    <Link
      className={view === 'administrativa' ? 'item-active' : 'item'}
      to={`/alumnos/${student.id}/administrativa`}
    >
      Administrativa
    </Link>
    <Link
      className={view === 'padres' ? 'item-active' : 'item'}
      to={`/alumnos/${student.id}/padres`}
    >
      Padres
    </Link>
    {studentPermission(user, student) &&
      <LinkButton
        fontSize="1.6em"
        width="14rem"
        margin="5rem 0 1rem 0"
        padding=".5rem 0"
        to={`/editar-alumno/${student.id}`}
      >
        Editar alumno
      </LinkButton>
    }
    {studentPermission(user, student) &&
      <ExportStudentProfile studentId={student.id} />
    }
  </div>
);

StudentProfileMenu.propTypes = {
  student: object,
  user: object,
  view: string
};

const mapState = state => ({
  user: state.getIn(['session', 'user']).toJS()
});

export default connect(mapState)(StudentProfileMenu);



// WEBPACK FOOTER //
// ./src/components/student/StudentProfileMenu.js